<template>
  <div>
    <CategoryFilters
      :name.sync="payload.name"
      :id.sync="payload.id"
      @apply="getCategories(payload)"
    />
    <loading v-show="loading" />
    <v-card v-show="!loading" elevation="4">
      <v-app-bar flat dense elevation="0" color="transparent">
        <v-toolbar-title> <h4>Categories</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <template>
          <v-data-table
            :headers="headers"
            :items="categories"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :items-per-page="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            @click:row="edit($event.id)"
            class="elevation-0"
          >
            <template v-slot:header.data-table-select="{ props, on }">
              <!-- COLOR Not working when props.indeterminate is true -->
              <v-simple-checkbox
                color="primary"
                v-ripple
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox
                color="primary"
                v-ripple
                :value="isSelected"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.image="{ item }">
              <v-avatar>
                <img :src="item.image" alt="John" />
              </v-avatar>
            </template>

            <template v-slot:item.subCategories="{ item }">
              <div>
                {{ Object.keys(item.subCategories).toString() }}
              </div>
            </template>

            <template v-slot:item.action="{ item }">
              <v-menu offset-y bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon class="gray--text">more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item link>
                    <v-list-item-title @click="edit(item.id)"
                      >Edit</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item link>
                    <v-list-item-title @click="deleteAndRefresh(item.id)"
                      >Delete</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// eslint max-nested-callbacks: ["error", 10]
import Helpers from "@/mixins/helpers";
import CategoryFilters from "./CategoryFilters.vue";
export default {
  components: {
    CategoryFilters
  },
  mixins: [Helpers],
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "Id",
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Subcategories",
          align: "left",
          value: "subCategories"
        },
        { text: "", value: "action", align: "right" }
      ],
      payload: {
        from: 0,
        to: 0,
        name: null,
        id: null
      }
    };
  },
  computed: {
    categories() {
      return this.$store.state.categories.categories;
    },
    totalItems() {
      return this.$store.state.categories.totalCategories;
    }
  },
  created() {
    this.getCategories(this.payload);
  },
  methods: {
    async getCategories(payload) {
      this.loading = true;
      await this.$store.dispatch("categories/LOAD_CATEGORIES", payload);
      this.loading = false;
    },
    updatePagination(pagination) {
      let payload = this.payload;
      (payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage),
        (payload.to =
          pagination.itemsPerPage === -1
            ? this.totalItems
            : pagination.itemsPerPage);
      this.getCategories(payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);

      if (res) {
        let payload = this.payload;
        (payload.from =
          pagination.page * pagination.itemsPerPage - pagination.itemsPerPage),
          (payload.to =
            pagination.itemsPerPage === -1
              ? this.totalItems
              : pagination.itemsPerPage);
        this.getCategories(payload);
      }
    }
  }
};
</script>
